module.exports = __webpack_public_path__ + "static/media/reachedTournamentTop10_30_35.a724dc1a.png";